import { StoreType, convertQuotationToDraftOrder, createDraftOrder } from "api/shopify";
import { Attachment, MaterialType, Pannel } from "types/canvasTypes";

interface ShopifyOrderButtonProps {
  color: "green" | "blue" | "purple";
  storeId: StoreType;
  storeName: string;
  label: string;
  slug: string;
  clientName: string;
  clientEmail: string;
  includeAttachement: boolean;
  materialOption: MaterialType;
  selectedLength: string;
  pannels: Pannel[];
  material: Attachment[];
  loading: boolean;
  onApiCall: (apiFunction: () => Promise<any>, storeName: string) => void;
}

const ShopifyOrderButton = ({
  color,
  storeId,
  storeName,
  label,
  slug,
  clientName,
  clientEmail,
  includeAttachement,
  materialOption,
  selectedLength,
  pannels,
  material,
  loading,
  onApiCall,
}: ShopifyOrderButtonProps) => {
  const handleClick = () => {
    const numberOfDoors = pannels.filter(
      (pannel) => pannel.isRPannel
    ).length;
    const order = convertQuotationToDraftOrder(
      {
        id: slug,
        createdBy: "Application",
        name: clientName,
        includeAttachement: includeAttachement,
        email: clientEmail,
        material: materialOption,
      },
      parseInt(selectedLength),
      pannels,
      material,
      numberOfDoors,
      storeId
    );
    console.log("Order:", order);

    onApiCall(
      () => createDraftOrder(order, storeId),
      storeName
    );
  };

  return (
    <button
      className={`edit-button btn-shopify btn-shopify--${color}`}
      disabled={pannels.length === 0 || loading}
      onClick={handleClick}
    >
      {label}
    </button>
  );
};

export default ShopifyOrderButton;
